import { PropsWithChildren, useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';

export const Portal = ({ id, zIndex = 1000, children }: PropsWithChildren<{ id?: string; zIndex?: number }>) => {
  const [wrapper, setWrapper] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const element = document.createElement('div');
    element.setAttribute('class', 'quipli-v2 relative');
    id && element.setAttribute('id', id);
    element.setAttribute('style', `z-index: ${zIndex}`);

    document.body.appendChild(element);
    setWrapper(element);

    return () => {
      if (element?.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, []);

  if (wrapper === null) return null;

  return createPortal(children, wrapper);
};
